/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useState } from "react";
import AppNotificationContextState, { createInitialState } from "./AppNotificationContextState";
import IAppNotificationContext from "./IAppNotificationContext";


export default class AppNotificationContextInstance implements IAppNotificationContext {
    private static readonly _langsamesPollingIntervall = 20000;
    private static readonly _schnellesPollingIntervall = 2000;

    private readonly _state: AppNotificationContextState;
    private readonly _setState: React.Dispatch<React.SetStateAction<AppNotificationContextState>>;

    constructor() {
        [this._state, this._setState] = useState<AppNotificationContextState>(createInitialState(AppNotificationContextInstance._langsamesPollingIntervall));
    }

    public get pollingIntervall(): number {
        return this._state.pollingIntervall;
    }

    public get refetch(): boolean {
        return this._state.refetch;
    }

    public startePolling(): void {
        this.setState(next => next.pollingIntervall = this.ermittlePollingIntervall(next));
    }

    public stoppePolling(): void {
        this.setState(next => next.pollingIntervall = 0);
    }

    public holeBenachrichtigungen(): void {
        this.setState(next => next.refetch = true);
    }

    public benachrichtigungenGeholt(): void {
        this.setState(next => next.refetch = false);
    }

    public readonly startePollingFuer = (benachrichtigungId: string): void => {
        this.setState(next => {
            const items = next.benachrichtigungIds;
            if (!items.find(id => id === benachrichtigungId)) {
                items.push(benachrichtigungId);
                next.benachrichtigungIds = items;
                next.pollingIntervall = this.ermittlePollingIntervall(next);
            }
        });
    }

    public readonly stoppePollingFuer = (benachrichtigungIds: string[]): void => {
        this.setState(next => {
            const items = this._state.benachrichtigungIds.filter(id => !benachrichtigungIds.find(b => b === id));
            next.benachrichtigungIds = items;
            next.pollingIntervall = this.ermittlePollingIntervall(next);
        });
    }

    private setState(modifyState: (next: AppNotificationContextState) => void) {
        this._setState((previous: AppNotificationContextState) => {
            const next: AppNotificationContextState = { ...previous };
            modifyState(next);
            return next;
        });
    }

    private readonly ermittlePollingIntervall = (state: AppNotificationContextState): number => {
        return (state.benachrichtigungIds.length > 0) ? AppNotificationContextInstance._schnellesPollingIntervall : AppNotificationContextInstance._langsamesPollingIntervall;
    }
}